<template>
  <div class="page-container">
    <div class="main">
      <!-- <div class="top">
        <h3 class="intro-txt">{{ $route.name }}</h3>
      </div> -->

      <page :url="url" :form="form" @reset="reset">
        <template slot="pageHeader">
          <div style="padding: 2px">
            总交易金额【{{ totalAmount }}】&nbsp;&nbsp;总手续费【{{
              totalFee
            }}】&nbsp;&nbsp;实收金额【{{ totalActualAmount }}】
          </div>
        </template>

        <template slot="tableSearch">
          <el-form-item label="订单号">
            <el-input
              v-model="form.orderId"
              placeholder="请输入订单号/商户订单号/渠道订单号"
              style="width: 350px"
              class="inputOrderId"
              @input="val => handleInput(val)"
            ></el-input>
            <div class="inputStyle" v-html="orderInputId"></div>
          </el-form-item>

          <el-form-item
            v-if="$store.state.roleId == '1070960390067716097'"
            label="支付渠道"
          >
            <el-select v-model="form.channelId" style="width: 120px">
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="item in payOption"
                :key="item.channelId"
                :label="item.channelName"
                :value="item.channelId"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            v-if="
              $store.state.roleId == '1070960390067716097' ||
              $store.state.roleId == '2125410685723869666'
            "
            label="商户"
          >
            <el-select
              v-model="form.appId"
              :popper-append-to-body="false"
              popper-class="eloption"
            >
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="merchant in merchantList"
                :label="merchant.value + '-' + merchant.name"
                :key="merchant.value"
                :value="merchant.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="订单状态">
            <el-select v-model="form.status" style="width: 100px" placeholder="请选择订单状态">
              <el-option label="全部" value=""></el-option>
              <el-option label="支付中" value="00"></el-option>
              <el-option label="支付成功" value="01"></el-option>
              <el-option label="支付失败" value="02"></el-option>
              <el-option label="超时取消" value="03"></el-option>
              <el-option label="交易退款" value="04"></el-option>
              <el-option label="待确认" value="06"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="回调状态">
            <el-select v-model="form.callbackStatus" style="width: 100px" placeholder="回调状态">
              <el-option label="全部" value=""></el-option>
              <el-option label="未回调" value="00"></el-option>
              <el-option label="回调成功" value="01"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="结算状态">
            <el-select v-model="form.settlementStatus" style="width: 100px" placeholder="结算状态">
              <el-option label="全部" value=""></el-option>
              <el-option label="未结算" value="00"></el-option>
              <el-option label="结算成功" value="01"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            v-if="$store.state.roleId == '1070960390067716097'"
            label="代理"
          >
            <el-select
              v-model="form.agentId"
              placeholder="请选择"
              :popper-append-to-body="false"
              popper-class="eloption"
            >
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="item in agentList"
                :key="item.agentId"
                :label="item.agentId + '-' + item.agentName"
                :value="item.agentId"
              ></el-option>
            </el-select>
          </el-form-item>


          <el-form-item label="Name">
            <el-input
              v-model="form.customerName"
              placeholder="请输入Name"
              style="width: 160px"
            ></el-input>
          </el-form-item>
          <el-form-item label="CPF">
            <el-input
              v-model="form.customerCert"
              placeholder="请输入CPF"
              style="width: 140px"
            ></el-input>
          </el-form-item>

          <el-form-item label="日期">
            <el-date-picker
              v-model="timeDate"
              type="datetimerange"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyyMMddHHmmss"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :clearable="false"
              :default-time="['00:00:00', '23:59:59']"
              @change="timeChange"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item v-if="$store.state.roleId != '1125110685723868888'" label="查看统计">
            <el-select
              v-model="form.showOrderCount"
              style="width: 60px"
              placeholder="否"
            >
              <el-option label="否" value="00"></el-option>
              <el-option label="是" value="01"></el-option>
            </el-select>
          </el-form-item>
        </template>

        <template slot="buttonArea">
          <el-button
            v-if="$store.state.roleId != '1125110685723868888'"
            :loading="loading"
            type="primary"
            @click="exportDetail"
            size="small"
          >
            导出订单</el-button
          >
        </template>

        <template slot="tableColumn">
          <el-table-column
            prop="orderId"
            width="350px"
            label="订单号"
            align="center"
          >
            <template slot-scope="{ row }">
              <div class="orderStyle" style="margin-bottom: 0px">
                <el-tag size="mini">代收</el-tag>{{ row.orderId }}
              </div>
              <div class="orderStyle" style="margin-bottom: 0px">
                <el-tag size="mini" type="success">商户</el-tag
                >{{ row.merchantOrderId }}
              </div>
              <div class="orderStyle">
                <el-tag size="mini" type="warning">渠道</el-tag
                ><span v-if="row.channelOrderId">{{ row.channelOrderId }}</span>
                <span v-else>--</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            v-if="$store.state.roleId != '1125110685723868888'"
            prop="appId"
            width="140px"
            label="商户"
            align="center"
          >
            <template slot-scope="{ row }">
              <div>{{ row.appId }}</div>
              <div>{{ row.merchantName }}</div>
            </template>
          </el-table-column>

          <el-table-column
            v-if="$store.state.roleId == '1125110685723868888'"
            prop="appId"
            width="140px"
            label="商户"
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="amount"
            width="80px"
            :formatter="$formatter.FenToYuan"
            label="订单金额"
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="payUrl"
            width="90px"
            label="支付链接"
            align="center"
          >
            <template slot-scope="{ row }">
              <el-popover
                v-if="row.payUrl"
                placement="right"
                width="320"
                trigger="click"
                popper-class="pay-url-popover"
              >
                <div class="pay-url-panel">
                  <qrcode :value="row.payUrl" :options="{ width: 220 }"></qrcode>
                  <el-input :value="row.payUrl" readonly size="small" class="pay-url-input">
                    <el-button slot="append" icon="el-icon-document-copy" @click.stop="copyPayUrl(row.payUrl)">复制</el-button>
                  </el-input>
                  <el-button type="text" @click="openPayUrl(row.payUrl)">打开链接</el-button>
                </div>
                <el-button slot="reference" type="text" size="small">查看</el-button>
              </el-popover>
              <span v-else>--</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="createDate"
            width="160px"
            label="创建/完成"
            align="center"
          >
            <template slot-scope="{ row }">
              <div v-if="row.createDate">
              {{
                $formatter.formatDate(
                  null,
                  null,
                  row.createDate + row.createTime,
                  null
                )
              }}
              </div>
              <div v-if="row.endTimeStr">
                {{
                  row.endTimeStr
                }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            prop="status"
            width="100px"
            label="订单状态"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag
                size="medium"
                :type="
                  scope.row.status === '00'
                    ? 'warning'
                    : scope.row.status === '01'
                    ? 'success'
                    : scope.row.status === '02' || scope.row.status === '03'
                    ? 'danger'
                    : 'primary'
                "
              >
                {{
                  $formatter.formatOrderStatus(
                    null,
                    null,
                    scope.row.status,
                    null
                  )
                }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column
            prop="callbackStatus"
            :formatter="$formatter.formatCallBackStatus"
            width="80px"
            label="回调"
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="settlementStatus"
            :formatter="$formatter.formatSettlementStatus"
            width="80px"
            label="结算"
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="freezeStatus"
            :formatter="$formatter.formatFreezeStatus"
            width="80px"
            label="冻结"
            align="center"
          >
          </el-table-column>
          
          <el-table-column
            v-if="$store.state.roleId == '1070960390067716097' || $store.state.roleId == '1125110685723868888'"
            prop="customerBankName"
            width="120px"
            label="PSP"
            align="center"
          >
            <template slot-scope="{ row }">
              <div v-if="row.customerBankName">
                <el-popover
                  v-if="row.customerBankName && row.customerBankName.length > 10"
                  placement="top-start"
                  width="200"
                  trigger="hover"
                  :content="row.customerBankName"
                >
                  <div slot="reference" class="remark">{{ row.customerBankName }}</div>
                </el-popover>
                <div v-else>{{ row.customerBankName }}</div>
              </div>
              <span v-else>--</span>
            </template>
          </el-table-column>

          <el-table-column
            v-if="$store.state.roleId == '1070960390067716097' || $store.state.roleId == '1125110685723868888'"
            prop="channelName"
            width="120px"
            label="支付渠道"
            align="center"
          >
          </el-table-column>

          <el-table-column
            v-if="$store.state.roleId == '1070960390067716097'"
            prop="routeId"
            :formatter="$formatter.formatYesNo"
            width="60px"
            label="强制"
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="endToEndId"
            width="120px"
            label="EndToEndId"
            align="center"
          >
            <template slot-scope="{ row }">
              <span v-if="row.endToEndId">{{ row.endToEndId }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="customerCert"
            width="120px"
            label="CPF"
            align="center"
          >
            <template slot-scope="{ row }">
              <span v-if="row.customerCert">{{ row.customerCert }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="customerName"
            width="120px"
            label="Name"
            align="center"
          >
            <template slot-scope="{ row }">
              <span v-if="row.customerName">{{ row.customerName }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="msg"
            width="160px"
            label="状态描述"
            align="center"
          >
            <template slot-scope="{ row }">
              <div v-if="row.msg">
                <el-popover
                  v-if="row.msg && row.msg.length > 10"
                  placement="top-start"
                  width="200"
                  trigger="hover"
                  :content="row.msg"
                >
                  <div slot="reference" class="remark">{{ row.msg }}</div>
                </el-popover>
                <div v-else>{{ row.msg }}</div>
              </div>
              <span v-else>--</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="sysRemark"
            width="150px"
            label="系统备注"
            align="center"
          >
            <template slot-scope="{ row }">
              <div v-if="row.sysRemark">
                <el-popover
                  v-if="row.sysRemark && row.sysRemark.length > 10"
                  placement="top-start"
                  width="200"
                  trigger="hover"
                  :content="row.sysRemark"
                >
                  <div slot="reference" class="remark">{{ row.sysRemark }}</div>
                </el-popover>
                <div v-else>{{ row.sysRemark }}</div>
              </div>
              <span v-else>--</span>
            </template>
          </el-table-column>

          <el-table-column
            v-if="$store.state.roleId == '1070960390067716097'"
            prop="feeRate"
            width="60px"
            label="费率"
            align="center"
          >
          </el-table-column>
          <el-table-column
            v-if="$store.state.roleId == '1070960390067716097'"
            prop="fee"
            width="80px"
            :formatter="$formatter.FenToYuan"
            label="手续费"
            align="center"
          >
          </el-table-column>

          <el-table-column
            v-if="$store.state.roleId == '1070960390067716097'"
            prop="agentId"
            width="120px"
            label="代理"
            align="center"
          >
            <template slot-scope="{ row }">
              <div>{{ row.agentId }}</div>
              <div>{{ row.agentName }}</div>
            </template>
          </el-table-column>

          <el-table-column
            fixed="right"
            label="操作"
            :width="operationColumnWidth"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                v-if="canRefreshOrder"
                type="primary"
                plain
                size="mini"
                @click="orderSuccess(scope.row)"
                >刷新
              </el-button>

              <el-button
                type="success"
                plain
                size="mini"
                :disabled="scope.row.status === '00' ? true : false"
                @click="orderNotify(scope.row)"
                >回调
              </el-button>

              <el-button
                v-if="$store.state.roleId == '1070960390067716097'"
                type="warning"
                size="mini"
                plain
                @click="handleModify(scope.row.orderId)"
                >修改
              </el-button>
              <el-button
                v-if="
                  $store.state.roleId == '1070960390067716097' &&
                  scope.row.freezeStatus
                "
                type="success"
                size="mini"
                plain
                @click="handleFrozen(scope.row.orderId)"
                >冻结详情
              </el-button>
              <el-button
                v-if="
                  $store.state.roleId == '1070960390067716097' &&
                  !scope.row.freezeStatus
                "
                type="danger"
                size="mini"
                plain
                @click="handleFrozenOrder(scope.row)"
                >冻结订单
              </el-button>
            </template>
          </el-table-column>
        </template>
      </page>
      <modify
        :is-show-modify-dialog.sync="isShowModifyDialog"
        :id="id"
      ></modify>
      <AddFronzen
        :show.sync="showDialog"
        :merchant-list="merchantList"
        :item="freezeItem"
        type="1"
      ></AddFronzen>
    </div>
  </div>
</template>

<script>
import Page from '@/components/Page.vue'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import moment from 'moment'
import Modify from './components/Modify.vue'
import AddFronzen from '../merchant/AddFronzen'

export default {
  name: 'Systems',
  components: {
    page: Page,
    qrcode: VueQrcode,
    Modify: Modify,
    AddFronzen: AddFronzen,
  },
  data() {
    return {
      url: '/order/selectList?payType=110',
      action: '',
      timeDate: [],
      payOption: [],
      id: '',
      loading: false,
      orderInputId: '',
      form: {
        orderId: '',
        appId: '',
        channelId: '',
        startDate: '',
        endDate: '',
        status: '',
        callbackStatus: '',
        settlementStatus: '',
        showOrderCount: '00',
      },
      showDialog: false,
      formData: null,
      totalAmount: '',
      totalFee: '',
      totalActualAmount: '',
      merchantList: [],
      agentList: [],
      isShowModifyDialog: false,
      freezeItem: {},
    }
  },
  computed: {
    canRefreshOrder() {
      return [
        '1070960390067716097',
        '2125410685723869666',
        '1125070436338499584',
        '1125410685723999999',
      ].includes(this.$store.state.roleId)
    },
    operationColumnWidth() {
      if (this.$store.state.roleId === '1070960390067716097') {
        return '300'
      }
      if (this.canRefreshOrder) {
        return '160'
      }
      return '100'
    },
  },
  methods: {
    timeChange(e) {
      if (e) {
        this.form.startDate = e[0]
        this.form.endDate = e[1]
      } else {
        this.form.startDate = moment().utcOffset("-03:00").subtract(4, 'hours').format('yyyyMMDDHH') + "0000"
        this.form.endDate = moment().utcOffset("-03:00").format('yyyyMMDD') + "235959"
        this.timeDate = [this.form.startDate, this.form.endDate]
      }
    },
    reset() {
      this.form.startDate = moment().utcOffset("-03:00").subtract(4, 'hours').format('yyyyMMDDHH') + "0000"
      this.form.endDate = moment().utcOffset("-03:00").format('yyyyMMDD') + "235959"
      this.timeDate = [this.form.startDate, this.form.endDate]

      this.showOrderCount = '00'
      this.totalAmount = ''
      this.totalFee = ''
      this.totalActualAmount = ''
      this.orderInputId = ''
    },
    handleModify(id) {
      this.id = id
      this.isShowModifyDialog = true
    },
    handleFrozen(id) {
      this.$router.push('/freezeBalance?orderId=' + id)
    },
    handleInput(val) {
      if (val.indexOf('2023') > -1) {
        let length = val.indexOf('2023')
        let str = val.split('2023')
        if (str[1].length >= 4) {
          let sub = val.substring(length, length + 8)
          let value = val.split(sub)
          this.orderInputId = `${value[0]}<span style="color:#E6A23C">${sub}</span>${value[1]}`
        } else {
          this.orderInputId = val
        }
      } else {
        this.orderInputId = val
      }
    },
    add() {
      this.action = 'addMerchant'
      this.formData = null
      this.showDialog = true
    },
    edit(row) {
      this.action = 'editMerchant'
      this.formData = row
      this.showDialog = true
    },
    handleFrozenOrder(row) {
      this.freezeItem = row
      this.showDialog = true
    },
    orderSuccess(row) {
      let orderId = row.orderId

      this.$confirm('确认要刷新吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.axios
            .post('/order/syncOrderStatus', {
              orderId: orderId,
            })
            .then(res => {
              if (res.code === 200) {
                // this.$bus.$emit('refresh') //通知刷新
                this.$notify({
                  title: '提示',
                  message: res.msg,
                  type: 'success',
                })
              } else {
                this.$notify.error({
                  title: '提示',
                  message: res.msg,
                })
              }
            })
        })
        .catch(() => {})
    },
    orderNotify(row) {
      let orderId = row.orderId

      this.$confirm('确认要回调吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.axios
            .post('/order/notifyOrder', { orderId: orderId })
            .then(res => {
              if (res.code === 200) {
                // this.$bus.$emit('refresh') //通知刷新
                this.$notify({
                  title: '提示',
                  message: res.msg,
                  type: 'success',
                })
              } else {
                this.$notify.error({
                  title: '提示',
                  message: res.msg,
                })
              }
            })
        })
        .catch(() => {})
    },
    copyPayUrl(payUrl) {
      if (!payUrl) {
        return
      }
      const textarea = document.createElement('textarea')
      textarea.value = payUrl
      textarea.setAttribute('readonly', 'readonly')
      textarea.style.position = 'fixed'
      textarea.style.left = '-9999px'
      document.body.appendChild(textarea)
      textarea.select()
      try {
        if (document.execCommand('copy')) {
          this.$message.success('复制成功')
          return
        }
        this.$message.error('复制失败，请手动复制')
      } catch (e) {
        this.$message.error('复制失败，请手动复制')
      } finally {
        document.body.removeChild(textarea)
      }
    },
    openPayUrl(payUrl) {
      if (payUrl) {
        const openedWindow = window.open(payUrl, '_blank', 'noopener,noreferrer')
        if (openedWindow) {
          openedWindow.opener = null
        }
      }
    },
    countAmount() {
      let param = {}

      let showOrderCount = this.form.showOrderCount
      if (showOrderCount != '01') {
        this.totalAmount = ''
        this.totalFee = ''
        this.totalActualAmount = ''
        return
      }

      for (let key in this.form) {
        let value = this.form[key]
        if (value !== '' && value !== null) {
          param[key] = value
        }
      }

      this.totalAmount = '...',
      this.totalFee = '...',
      this.totalActualAmount = '...',

      param.payType = 110
      this.$axios.get('/order/amountCount', { params: param }).then(res => {
        if (res.code === 200) {
          this.totalAmount = this.$formatter.FenToYuan(
            null,
            null,
            res.data.amount,
            null
          )
          this.totalFee = this.$formatter.FenToYuan(
            null,
            null,
            res.data.fee,
            null
          )
          this.totalActualAmount = this.$formatter.FenToYuan(
            null,
            null,
            res.data.actualAmount,
            null
          )
        }
      })
    },
    exportDetail() {
      this.loading = true
      this.axios
        .get('/order/selectListForExport?payType=110', {
          params: this.form,
        })
        .then(res => {
          if (res.code != 200) {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          } else {
            this.$message({
              message: res.msg,
              type: 'success',
            })
          }
        })
      this.loading = false
    },
  },
  created() {
    this.form.startDate = moment().utcOffset("-03:00").subtract(4, 'hours').format('yyyyMMDDHH') + "0000"
    this.form.endDate = moment().utcOffset("-03:00").format('yyyyMMDD') + "235959"
    this.timeDate = [this.form.startDate, this.form.endDate]

    this.$axios
      .get('/merchant/selectListForOption', { params: {} })
      .then(res => {
        this.merchantList = res.data
      })

      if (this.$store.state.roleId == '1070960390067716097'){
        this.$axios.get('/agent/selectAgentForOption', { params: {} }).then(res => {
          this.agentList = res.data
        })
      }

    this.$axios
      .get('/routeChannelInfo/selectByCondition', { params: {} })
      .then(res => {
        res.data.map(item => {
          if (item.productId == 110) {
            this.payOption.push(item)
          }
        })
      })
  },
}
</script>

<style lang="scss" scoped>
.el-button--warning.is-plain.is-disabled,
.el-button--warning.is-plain.is-disabled:hover,
.el-button--warning.is-plain.is-disabled:focus,
.el-button--warning.is-plain.is-disabled:active,
.el-button--success.is-plain.is-disabled,
.el-button--success.is-plain.is-disabled:hover,
.el-button--success.is-plain.is-disabled:focus,
.el-button--success.is-plain.is-disabled:active {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #c0c4cc;
}
.remark {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
.orderStyle {
  text-align: left;
}
.orderStyle .el-tag {
  margin-right: 6px;
}
.el-form-item {
  margin-bottom: 5px;
}
.el-form-item__content {
  position: relative;
}
.inputStyle {
  position: absolute;
  top: 0;
  left: 0;
  // width: 100%;
  height: 34px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  font-size: 13px;
  pointer-events: none;
  color: #606266;
}

::v-deep .inputOrderId {
  position: relative;
  z-index: 1;
  .el-input__inner {
    color: transparent;
    background-color: transparent;
    caret-color: #606266;
  }
}
</style>
